import React from 'react';


class Edit extends React.Component {
	state = {
		value: this.props.value,
	}
	
	render() {
		const { value } = this.state;
		return (
			<div>
						<div className="editable-row-text">
							{
								value?
								value.toString()
									:
									''
							}
						</div>
			</div>
		);
	}
}

export default Edit;



// WEBPACK FOOTER //
// ./src/routes/dictionary/edit.js